import styled, { css } from 'styled-components';

export const Option = styled.span<CheckedProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.125rem;
  width: 1.125rem;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ selected, disabled, theme }) => {
    if (disabled) return theme.colors.textGrey;
    return selected ? theme.colors.lightBlue : '#B3ADA7';
  }};
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.colors.lightestGray : null};
  flex-shrink: 0;
  transition: border-color 0.1s;
`;

export const Checked = styled.div<CheckedProps>`
  width: 0.625rem;
  height: 0.625rem;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.colors.midGrey : theme.colors.lightBlue};
  opacity: ${({ selected }) => (selected ? 1 : 0)};
`;

export const Text = styled.span`
  margin-top: 2px;
  margin-left: 1rem;
`;

export const Label = styled.label<CheckedProps>`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;

  &:hover > ${Option} {
    border-color: ${({ selected, disabled, hasError, theme }) => {
      if (hasError) return null;
      return selected && !disabled ? '#0584b5' : theme.colors.textGrey;
    }};
  }

  ${Text} {
    color: ${({ selected, disabled, theme }) => {
      if (disabled) return theme.colors.textGrey;
      return selected ? '#333' : '#B3ADA7';
    }};
  }

  &:hover ${Text} {
    color: ${({ selected, disabled, hasError, theme }) => {
      if (disabled || hasError) return null;
      return selected ? '#333' : theme.colors.textGrey;
    }};
  }

  ${({ hasError, theme }) =>
    hasError &&
    css`
      & > ${Option} {
        border-color: ${theme.colors.secondary.red};
      }

      & ${Text} {
        color: ${theme.colors.secondary.red};
      }

      & ${Checked} {
        background-color: ${theme.colors.secondary.red};
      }
    `}
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  &:disabled {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }
`;

interface CheckedProps {
  selected?: boolean;
  disabled?: boolean;
  hasError?: boolean;
}
